const KEY = 'EVENT_SCHEDULE';

export { KEY };
